/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ActivePromoCodeRequest
 */
export interface ActivePromoCodeRequest {
  /**
   *
   * @type {string}
   * @memberof ActivePromoCodeRequest
   */
  code: string
}

/**
 * Check if a given object implements the ActivePromoCodeRequest interface.
 */
export function instanceOfActivePromoCodeRequest(
  value: object
): value is ActivePromoCodeRequest {
  if (!('code' in value) || value['code'] === undefined) return false
  return true
}

export function ActivePromoCodeRequestFromJSON(
  json: any
): ActivePromoCodeRequest {
  return ActivePromoCodeRequestFromJSONTyped(json, false)
}

export function ActivePromoCodeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ActivePromoCodeRequest {
  if (json == null) {
    return json
  }
  return {
    code: json['code'],
  }
}

export function ActivePromoCodeRequestToJSON(
  value?: ActivePromoCodeRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    code: value['code'],
  }
}
